import { Component, EventEmitter, Inject, Output, signal } from '@angular/core';
import { PromoType } from '@data/domain/promo.entity';
import { DIALOG_DATA, DialogRef } from '@shared/component.dialog';
import { ContentPromoDetailComponent } from './components/content-promo-detail/content-promo-detail.component';
import { FooterPromoDetailComponent } from './components/footer-promo-detail/footer-promo-detail.component';
import { HeaderPromoDetailComponent } from './components/header-promo-detail/header-promo-detail.component';
import { PromoDetailData } from './promo-detail';
@Component({
  selector: 'app-promo-detail',
  standalone: true,
  imports: [HeaderPromoDetailComponent, ContentPromoDetailComponent, FooterPromoDetailComponent],
  templateUrl: './promo-detail.component.html',
  styleUrl: './promo-detail.component.scss'
})
export class PromoDetailComponent {
  @Output() buy: EventEmitter<PromoDetailData> = new EventEmitter();

  promoType = signal<PromoType>(localStorage.getItem('promoType') as PromoType);
  deviceId!: string;

  constructor(
    // using informatve name for data
    @Inject(DIALOG_DATA) public data: PromoDetailData,
    private readonly dialogRef: DialogRef
  ) { }

  onClickClose() {
    this.dialogRef.close();
  }

  onClickBuy() {
    this.buy.emit(this.data);
  }

}
